import {useParams} from "react-router-dom";
import usePaymentRedirect from "./usePaymentRedirect";
import {useContext, useState} from "react";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {GlobalContext} from "../../GlobalReducer";
import {checkFastOrder} from "../../api/checkout";
import {OrderInterface} from "../../interfaces/customer/OrderInterface";
import {Helmet, HelmetProvider} from "react-helmet-async";
import ChooseYourLook from "../main/ChooseYourLook";
import HorizontalModelSlider from "../main/NowBuy";

type QueryDataParams = {
    uid: string
}
export default function FastPaymentLink() {

    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);
    const [order, setOrder] = useState<OrderInterface|undefined>(undefined)
    const [error, setError] = useState<string|undefined>(undefined)

    const queryData = useParams<QueryDataParams>();


    if(queryData.uid){
        checkFastOrder(queryData.uid).then((response: any) => {
            setOrder(response.order)
        }, (error: any) => {
            setError(error.response?.data?.message || error.response?.data?.detail)
        })
    }

    usePaymentRedirect(order, dispatch)

    return (<section className="page-404 pt" style={{padding: "300px 0"}}>
        <HelmetProvider><Helmet>
            <meta name="prerender-status-code" content="404"/>
        </Helmet></HelmetProvider>
        <div className="page-404__wrap">
            <h4 className="f-exp">
                Ошибка при переадресации на форму оплаты
            </h4>
            <p>
                {error ? error : 'Ссылка на оплату не найдена'}
            </p>
        </div>
    </section>)
}